// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"fe8bc80a","1846":"31d6cfe0","3438":"b1ace781","4404":"c9c95fa5","8473":"f77496c0"}[chunkId] + ".chunk.css";
};